import React, { useContext, useEffect, useState } from "react";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import Button from "../../../components/shared/button/Button";
import UsersList from "../../../components/users/list";
import { getUserContacts } from "../../../context/users/action";
import { DB_DEFAULTS } from "../../../firebase/collections";
import { useTranslation } from "react-i18next";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  uid?: string;
  onLoad: any;
  loadedData?: any[] | null;
}

const MyContactsList = ({ uid, onLoad, loadedData, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  // Loading list
  const [loading, setLoading] = useState<boolean>(false);

  // Eventual error
  const [errors, setErrors] = useState<any>(false);

  // Local array of data
  const [data, setData] = useState<any[]>([]);

  // Pagination
  const [lastItem, setLastItem] = useState<any>(null);
  const [limit, setLimit] = useState<number>(DB_DEFAULTS.LIMIT);
  const [canLoadMore, setCanLoadMore] = useState<boolean>(true);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const mapData = (array: any[]): any[] => {
    let _array: any[] = [...array];

    _array = _array.map((item: any) => item.contact);

    return _array;
  };

  const handleLoadingVars = (array: any[]): void => {
    if (!array || array.length < limit) {
      setCanLoadMore(false);
    }

    // Track last element value for pagination
    setLastItem(array[array.length - 1]);
  };

  /**
   * Load events from database
   * @function
   * @async
   */
  const loadData = async () => {
    if (!uid) {
      return;
    }

    setLoading(true);

    try {
      let _data = await getUserContacts(uid, limit, lastItem);

      handleLoadingVars(_data);

      _data = mapData(_data);

      setData([...data, ..._data]);
    } catch (err) {
      setErrors(err);
      console.error(err);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.general.description",
        callback: () => {
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = (user: any) => {
    let _data = [...data.filter((u) => u.uid !== user.uid)];

    setData(_data);

    // Update last element value for pagination
    setLastItem(_data[_data.length - 1]);
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[MyContactsList] init");

    // If loaded, set from parent. Else load from db
    if (!!loadedData) {
      console.log("Preloaded data, no query");
      setData(loadedData);
      handleLoadingVars(loadedData);
    } else {
      console.log("No preloaded data, do query");
      loadData();
    }
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[MyContactsList] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to data in order to load data
   */
  useEffect(() => {
    if (data && data.length) {
      // Emit load
      onLoad(data);
    }
  }, [data]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="my-contacts profile-section">
      <div className="header">
        <h1>{t("pages.profile.my_contacts.title")}</h1>
        <p className="mw-50p">{t("pages.profile.my_contacts.description")}</p>
        <div className="image">
          <img src="/assets/images/undraw/search_people.png"/>
        </div>
      </div>

      {!!data && (
        <UsersList
          users={data}
          showPhone={false}
          showEmail={false}
          showCompany={true}
          showRole={true}
          showDelete={true}
          showChat={true}
          onDelete={deleteUser}
        />
      )}

      {/* Loading */}
      {!!loading && (
        <div className="list-loading">
          <i className="fas fa-spin fa-spinner"></i>
        </div>
      )}

      {/* Load more button */}
      {!loading && !!canLoadMore && (
        <div className="load-more">
          <Button className="btn btn-primary" onClick={loadData}>
            Load more
          </Button>
        </div>
      )}
    </div>
  );
};
export default MyContactsList;
